<template>
    <div class="home-promo-section" v-if="pageSetup != null && promoItems != null">
        <div class="promo-carousel">
            <swiper :options="swiperOption" ref="promoCarousel">
                <swiper-slide v-for="(slide, index) in promoItems" :key="index">
                    <div class="promo-pic" :style="'background-image: url(' + slide.acf.project_img_carousel + ')'">
                        <div class="container container-promo" v-if="!isMobileChecker">
                            <div class="slide-info">
                                <div class="year"><span>{{ parseInt(slide.acf.full_info.init.data) }}</span></div>
                                <div class="name"><h2>{{ slide.acf.project_name_carousel }}</h2></div>
                                <div class="info-list">
                                    <ul>
                                        <li><p>{{ slide.acf.project_type.name }}</p></li>
                                        <li><p>{{ slide.acf.full_info.location.data }}</p></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="swiper-controls promo-controls">
                            <div class="container">
                                <div class="promo-btn-prev slider-btn">
                                    <svgIcon name="left-arrow" class="icon-left-arrow"/>
                                </div>
                                <div class="promo-btn-next slider-btn">
                                    <svgIcon name="right-arrow" class="icon-right-arrow"/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="slide-info-mobile" v-if="isMobileChecker">
                        <div class="year"><span>{{ parseInt(slide.acf.full_info.init.data) }}</span></div>
                        <div class="name"><h2>{{ slide.acf.project_name_carousel }}</h2></div>
                        <div class="info-list">
                            <ul>
                                <li><p>{{ slide.acf.project_type.name }}</p></li>
                                <li><p>{{ slide.acf.full_info.location.data }}</p></li>
                            </ul>
                        </div>
                    </div>
                </swiper-slide>
            </swiper>
            
            <!-- <div class="swiper-pagination promo-pagination"></div> -->
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import svgIcon from '@/components/partials/SvgIcon.vue'
    export default {
        name: 'home-promo-section',
        components: {
            svgIcon,
        },
        data () {
            return {
                dataArr: null,
                swiperOption: {
                    speed: 1500,
                    observer: true,
                    observeParents: true,
                    effect: 'fade',
                    slidesPerView: 1,
                    simulateTouch: true,
                    watchSlidesVisibility: true,
                    loop: true,
                    // lazy: {
                    //     loadPrevNext: true,
                    //     loadOnTransitionStart: true
                    // },
                    autoplay: {
                        delay: 3000,
                        disableOnInteraction: true,
                    },
                    navigation: {
                        nextEl: '.promo-btn-next',
                        prevEl: '.promo-btn-prev',
                    },
                    // pagination: {
                    //     el: '.promo-pagination',
                    //     type: 'bullets',
                    //     clickable: true,
                    // },
                },
            }
        },
        computed: mapGetters({
            pageSetup: 'loadIndexPage',
            promoItems: 'loadPromoCarouselItems',
            isMobileChecker: 'loadIsMobileChecker',
        }),
        methods: {
            startLoader() {
                // this.$parent.$parent.$refs.topProgress.start();
            },
            getPromoItems() {
                if (this.pageSetup != null) {
                    if (this.promoItems == null) {
                        const data = this.pageSetup.promo_carousel_items;
                        var id_str = '';
                        for (var i=0; i<data.length; i++) {
                            id_str = id_str + data[i].project.ID
                        }
                        var correct_str = id_str.match(/.{1,4}/g);
                        var id_s = correct_str.join(",");
                        this.$store.dispatch('getPromoItemsByIDs', id_s);
                    }
                }
            },
        },
        beforeCreate() {
        },
        created () {
        },
        mounted() {
            this.getPromoItems();
            this.$store.watch(
                (state) => state.pageSetup,
                (newValue) => {
                    if (newValue) 
                    this.getPromoItems();
                }
            );
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/home-page/home-promo.scss';
    @import '@/styles/components/home-page/respond/home-promo-respond.scss';
</style>